import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import { getUserInfo } from './api/request/park'
import tools from '@/utils/tools'
import createSessionStoragePlugin from './plugin/vuex-session-storage'

export default new Vuex.Store({
  state: {
    token: "",
    islogin: true,
    requestCancels: [], // 当前路由的所有Axios请求取消函数
    dimensionList: {},
    currentUserInfo: {}, // 当前用户信息
  },
  getters: {

  },
  mutations: {
    loginSuccess (state, payload) {
      state.islogin = payload;
    },
    setDimensionList (state, payload) {
      payload.forEach((item) => {
        for (let key in item) {
          if (item.hasOwnProperty(key)) {
            state.dimensionList[key] = item[key];
          }
        }
      })
    },
    set_currentUserInfo: (state, info) => {
      state.currentUserInfo = info
    }
  },
  actions: {
    async GetCurrentUserInfo ({ commit }) {
      // 获取当前用户信息
      try {
        let res = await getUserInfo({
          Token: tools.getCookie('Token')
        })
        let { code, data, msg } = res.data
        console.log('datause', tools.decodeAES(data))
        let datause = tools.decodeAES(data)
        if (code === 200) {
          commit('set_currentUserInfo', datause)
        } else {
          console.error('获取用户信息失败:', msg)
          commit('set_currentUserInfo', null)
        }
      } catch (error) {
        console.error('获取用户信息异常:', error)
        commit('set_currentUserInfo', null)
      }
    },
    
    // 设置假用户信息用于测试
    setMockUserInfo({ commit }) {
      const mockUserInfo = {
        userName: "测试用户",
        name: "张三",
        id: "123456",
        phone: "13800138000",
        email: "test@example.com",
        company: "测试公司",
        role: "user"
      };
      commit('set_currentUserInfo', mockUserInfo);
    }
  },
  modules: {},
  plugins: [createSessionStoragePlugin()]
});
